export class QuestionForm {
  public id: number;
  public title: string;
  public description: string;
  public imageURL: string;
  public isActive: boolean;
  public isLinked: boolean;
  public showHomePage: boolean;
  public lastChange: string;
  public authorName: string;
  public type: number;
  public evaluation?: Evaluation;
  public singleChoices?: Choice[];
  public multiChoices?: Choice[];

  public answerId: number;
  public multiAnswerIds: number[];
  public answerText: string;
  public stars: number;

  constructor(
    id = NaN,
    title = "",
    description = "",
    imageURL = "",
    isActive = true,
    showHomePage = true,
    isLinked = false,
    lastChange = "",
    authorName = "",
    type = 0,
    evaluation?: Evaluation,
    singleChoices?: Choice[],
    multiChoices?: Choice[],
    answerId = NaN,
    multiAnswerIds: number[] = [],
    answerText = "",
    stars = 0
  ) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.imageURL = imageURL;
    this.isActive = isActive;
    this.isLinked = isLinked;
    this.showHomePage = showHomePage;
    this.lastChange = lastChange;
    this.authorName = authorName;
    this.type = type;
    this.evaluation = evaluation;
    this.singleChoices = singleChoices;
    this.multiChoices = multiChoices;

    this.answerId = answerId;
    this.multiAnswerIds = multiAnswerIds;
    this.answerText = answerText;
    this.stars = stars;
  }
}

export class Evaluation {
  constructor(public maxStars: number) {
    this.maxStars = maxStars;
  }
}

export class Choice {
  constructor(public id: number, public answerText: string) {
    this.id = id;
    this.answerText = answerText;
  }
}
